import { render, staticRenderFns } from "./office-ops.vue?vue&type=template&id=05a365ec&scoped=true&"
import script from "./office-ops.vue?vue&type=script&lang=js&"
export * from "./office-ops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a365ec",
  null
  
)

export default component.exports